import { SET_CURRENT_CONTENT, SET_MSG_CONTENT, FETCH_CONTENT, SET_CONTENT, SET_COMMUNITIES, SET_USERS_FOR_CONTENT, SET_COURSES , SEARCH_CONTENT } from "../actions/contentActions";


const initialState: ContentReducerState = {
    contentItems: [],
    currentContent: undefined,
    communities: [],
    users: [],
    courses: []
}

const contentReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CONTENT:
            return {
                ...state,
                contentItems: action.value
            }
        case SET_CURRENT_CONTENT:
            return {
                ...state,
                currentContent: action.value
            }
        case FETCH_CONTENT:
            return {
                ...state,
                content: action.value
            }

        case SEARCH_CONTENT:
            return {
                ...state,
                content: action.value
            }
        case SET_COURSES:
            return {
                ...state,
                courses: action.value
            }
        case SET_COMMUNITIES:
            return {
                ...state,
                communities: action.value
            }
        case SET_USERS_FOR_CONTENT:
            return {
                ...state,
                users: action.value
            }
        case SET_MSG_CONTENT:
            return {
                ...state,
                msgContent: action.value
            }
        default:
            return state;
    }
}

export interface ContentReducerState {
    contentItems: AdminContentItem[],
    currentContent: AdminContentItem | undefined,
    communities: any[],
    users: any[],
    courses: any[]
}

export interface AdminContentItem {
    id?: number;
    content_id?: string;
    title?: string;
    type?: string;
    created?: any;
    publish_amount?: number;
    tags?: any[];
    created_by?: any;
    show_item_in_search?: boolean;
    community?: string;
    thumbnail?: any;
    file?: any;
    link?: any;
    description?: any;
    modified?: any;
    modified_by?: any;
    who_can_see?: number
    uploaded_by?: any;
    m_id?: string;//modifier id
    c_id?: string;//creator id
    m_name?: string;
    c_name?: string;
    u_name?: string;
    status?: string;
    created_on?: any;
    file_type: string;
    related : {label: string , value : string}[];
    division?: string;
}

export default contentReducer;